import React, { Fragment, Component } from 'react'
import moment from 'moment'
import { mapQueryString, withApiService } from '../../api'
import { Label, Input } from 'reactstrap'
import { DatetimePickerTrigger } from 'rc-datetime-picker'
import axios from 'axios'
import { connect } from 'react-redux'
//import { apiReport } from '../../store/actions/companyActions';
import ModalBase from '../Plugins/MainModals/ModalBase';
import ModalReport from './ModalReport';
//import store from '../../store/store';
import { SearchClient, SearchProvider,SearchBranchSelect, SelectNormal, SearchBranchGroupsSelect }  from '../Plugins/SpecialForm';
import { URL as CompanyUrl } from '../../config'

const hasBranch = branch => branch && branch.id
class ReportItemRow extends Component {

    constructor(props) {
        super(props)
        this.state = {
            // start: moment().subtract(1, 'months'),
            start: props.maxDateRange ? undefined : moment().subtract(1, 'months'),
            end: props.maxDateRange ? undefined : moment(),
            query: {
                date_from: `${moment().subtract(1, 'months').format('YYYY-MM-DD')} 00:00:00`,
                date_to: `${moment().format('YYYY-MM-DD')} 23:59:59`,
                token: localStorage.getItem('token'),
                branch_id: props.autoBranch && props.branch ? props.branch.id : undefined,
                branch_group_id: props.autoBranchGroup && props.branch ? props.branch.branch_group_id : undefined,
                client_id: undefined,
                provider_id: undefined,
                target_type: 'company',
                tz: props.company.time_zone_offset,
            },
            loading: false,
            isLoading:false,
            selected:null,
            uploading: false,
        }
    }

    componentDidUpdate(prevProps){
        if(
            this.props.autoBranch
            && this.props.branch.id !== prevProps.branch.id
        ){
            this.setState(prevState => ({
                query:{
                    ...prevState.query,
                    branch_id: this.props.branch.id
                }
            }))
        }
        if(
            this.props.autoBranchGroup
            && this.props.branch.branch_group_id !== prevProps.branch.branch_group_id
        ){
            this.setState(prevState => ({
                query:{
                    ...prevState.query,
                    branch_group_id: this.props.branch.branch_group_id
                }
            }))
        }
    }

    handleSetStart = start => {

        this.setState(prevState => ({
            start,
            query: {...prevState.query, date_from: `${start.format('YYYY-MM-DD')} 00:00:00` }
        }))
    }

    handleSetEnd = end => {
        this.setState(prevState => ({
            end,
            query: {...prevState.query, date_to: `${end.add('minute').format('YYYY-MM-DD')} 23:59:59` }
        }))
    }

    prefetch = (event, endpoint,p) => {
        event.persist()
        event.preventDefault()
        this.toggleLoading()
        console.log('endpoint',endpoint)
        axios.get(endpoint)
            .then((res) => {
                console.log("res prefetch",res)
                const a = document.createElement("a");
                const extension = res.headers['content-type'].split(";")[0];
                //asi se usaba antes
                // a.href = URL.createObjectURL(new Blob([res.data], { type: this.getExtension(res.headers['content-type'])  }));
                // a.download = `${this.props.company.name} ${this.props.title}.${this.getExtension(res.headers['content-type'])}`;


                a.href = URL.createObjectURL(new Blob([res.data], { type: this.getExtension(extension)  }));
                a.download = `${this.props.company.name} ${this.props.title}.${this.getExtension(extension)}`;
                a.click();
            })

            .catch((err) => {
                const errorCode = (err
                    && err.response
                    && err.response.data
                    && err.response.data.error_code)
                    || "ER000";

                const errorMessage = (err
                    && err.response
                    && err.response.data
                    && err.response.data.description)
                    || "Algo salio mal, por favor intente nuevamente";

                switch (errorCode){
                    case "ER023":
                        this.props.notification
                            .show({
                                type: "error",
                                title: `Error ${errorCode}`,
                                msg: "No existen resultados para los parametros seleccionados"
                            });
                        break;
                    default:
                        this.props.notification
                            .show({
                                type: "error",
                                title: `Error ${errorCode}`,
                                msg: errorMessage
                            })
                        break;
                }
            })
            .finally(() => this.toggleLoading())
    }
    getExtension = (header) =>{
        const type = header.split('/').pop()
        const map = {
            'vnd.openxmlformats-officedocument.spreadsheetml.sheet': 'xlsx'
        }

        return map[type] || type;
    }
    toggleLoading = () => {
        this.setState(prevState => ({ loading: !prevState.loading }))
    }

    setBranch = ({ name, value }) => {
        this.setState(prevState => ({
            query: {
                ...prevState.query,
                [name]: value
            }
        }))

        setTimeout(() => {
            this.props.logBranchSelection(this.state)
        }, 1)
    }

    setUserEntity = ( name, value) => {
        if(name ==='branch_id' || name ==='branch_group_id' || name === 'provider_id' ? name : name && value){
            this.setState(prevState => ({
                query: {
                    ...prevState.query,
                    [name]: value
                }
            }))

        }
    }

    isValidDateRange = ({ end, start }) => {
        const { withDates, maxDateRange } = this.props
        if (withDates || maxDateRange) {
            if (!end || !start) {
                return false
            }

            return moment(end.format('YYYY-MM-DD')).isSameOrAfter(start.format('YYYY-MM-DD'), 'day')
        }

        return true
    }

    isGenerateButtonEnabled = (dates, query, { withBranches, withBranchGroups, withClients, withProviders, withTargetType, forceCity }) => {

        let rules = [this.isValidDateRange(dates)]
        if (withBranches) {
            rules.push(query.branch_id)
        }

        if (withBranchGroups) {
            rules.push(query.branch_group_id)
        }

        if (withClients) {
            rules.push(query.client_id)
        }

        if (withProviders) {
            rules.push(query.provider_id)
        }

        if (withTargetType) {
            rules.push(query.target_type)
        }

        if (forceCity) {
            if(this.props.cityId){
                rules.push(this.props.cityId)
            }else{
                rules.push(query.city_id)
            }
        }

        return rules.every($0 => $0)
    }

    buildQueryString = (query, { withDates, withBranches, withBranchGroups, branchAsParameter, branchGroupAsParameter, withClients, appendingQueryString, withProviders, withTargetType, withShoppers, withoutToken, autoBranch, autoBranchGroup, branch, withoutTimezone, withTimezone, forceCity, cityId }) => {
        const object = {...query}

        this.props.logQueryBuildStart(object)

        if (!withDates) {
            delete object.date_from
            delete object.date_to
            if(!withTimezone) {
                delete object.tz
            }
        }

        if (withoutTimezone || !withDates) {
            if(!withTimezone) {
                delete object.tz
            }
        }

        if (!withBranches || branchAsParameter) {
            delete object.branch_id
        }

        if (!withBranchGroups || branchGroupAsParameter) {
            delete object.branch_group_id
        }

        if (!withClients) {
            delete object.client_id
        }

        if (!withProviders && !withShoppers) {
            delete object.provider_id
        }

        if (!withTargetType) {
            delete object.target_type
        }

        if (withoutToken) {
            delete object.token
        }

        if (!withoutToken) {
			object.token = localStorage.getItem('token')
		}

        if (autoBranch && branch && branch.id && !branchAsParameter) {
            object.branch_id = branch.id
            this.props.logQueryBuildAutoBranch({ branch, query: object })
        }

        if (autoBranchGroup && branch && branch.branch_group_id) {
            object.branch_group_id = branch.branch_group_id
            this.props.logQueryBuildAutoBranchGroup({ branch, query: object })
        }

        if(forceCity){
            if(cityId){
                object.city_id = cityId
            }
        }

        this.props.logQueryBuildEnd(object)
        return mapQueryString(object, appendingQueryString)
    }

    buildURL = (dates, query) => {
        const { url } = this.props

        if (this.isValidDateRange(dates)) {
            if (typeof url === 'function') {
                return `${url({ query })}${this.buildQueryString(query, this.props)}`
            }

            return `${url}${this.buildQueryString(query, this.props)}`
        }

        return '#'
    }

    buildTitle = () => {
        const { title } = this.props

        if (typeof title === 'function') {
            return title(this.state.query)
        }

        return title
    }

    open_modal=(id,modal)=> {
        this.setState({
            [modal]:id,
        })
        this.refs[modal].toggleModal()
    }
    SearchAction(query){
        this.getAllClients(1,query)
    }

    onCityChange(event) {
        this.setState((prevState) => ({
            [this.props.title]: event.value,
            query: {
                ...prevState.query,
                city_id: event.value
            }
        }))
    }

    prepareUpload({target}){
        this.setState({ uploading: true });
        let data = new FormData();
        data.append('file', target.files[0]);

        axios.post(`${CompanyUrl + this.props.company.id}/bancamiga-report`, data).then(() => {
            this.setState({ uploading: false });
            this.props.notification.show({
                type: "success",
                title: "¡Éxito!",
                msg: "Archivo subido con éxito. En breves estará disponible en su correo electrónico"
            })
        }).catch((err) => {
            this.setState({ uploading: false });
            if(err.message && err.message !== 'generic')
                this.props.notification.show({
                    type: "error",
                    title:`Error ${err && err.data && err.data.error_code}`,
                    msg: err.message
                });
            else{
                this.props.notification.show({
                    type: "error",
                    title:`Error ${err && err.data && err.data.error_code}`,
                    msg: "Error al subir el archivo, por favor intente nuevamente"
                });
            }
        })
    }

    render = () => {

        const shortcuts = {
            Today: moment(),
            Yesterday: moment().subtract(1, 'days'),
            Clear: moment()
        };

        const TARGET_TYPES = [
            {
                value: "company",
                name: "Compañía"
            },
            {
                value: "city",
                name: "Ciudad"
            },
            {
                value: "branch",
                name: "Comercio"
            },
            {
                value: "branch_group",
                name: "Grupo de comercio"
            },
            {
                value: "category",
                name: "Categoría"
            },
            {
                value: "good",
                name: "Producto"
            },
        ]

        const { activateModal,withDates, buttonText, loadingText, withBranches, branches, withClients, withCityFilter, forceCity, clients, providers, withProviders, withShoppers, withTargetType, withoutPrefetch, maxDateRange, withBranchGroups, withFile } = this.props,
        { start, end, query, loading } = this.state
        let cityLabel = this.props.loadingText;
        if(forceCity && this.props.cityId && this.props.companyCities.length > 0){
            cityLabel = this.props.companyCities.find(city => city.id === this.props.cityId).name
        }


        return<tr>
            <td className="text-left">
                <Label className={'text-left'} style={{width:`100%`}}>{this.buildTitle()}</Label>
                <div className={withTargetType ? 'd-flex flex-row align-items-end w-100' : ''} style={{ gap: withTargetType ? '10px' : '0' }}>
                    {withBranches && (
                        <SearchBranchSelect
                            change={(e) => this.setUserEntity( 'branch_id', ( e[0] && e[0].id )) }
                            clear={() => this.setUserEntity( 'branch_id', ( undefined && undefined )) }
                            fromReports={this.props.withAllBranches ? false : true }
                        />
                    )}
                    {withBranchGroups && (
                        <div className="w-100">
                            <SearchBranchGroupsSelect
                                change={(e) => this.setUserEntity( 'branch_group_id', ( e[0] && e[0].id )) }
                                clear={() => this.setUserEntity( 'branch_group_id', ( undefined && undefined )) }
                                dontClearInput={true}
                                fromReports={this.props.withAllBranches ? true : false }
                            />
                        </div>
                    )}
                    {withTargetType && (
                        <div className="d-flex flex-column w-75">
                            <select
                                className="form-control"
                                value={query.target_type}
                                onChange={(e) => this.setUserEntity('target_type', e.target.value)}
                            >
                                {
                                    TARGET_TYPES.map((type, index) => (
                                        <option key={index} value={type.value}>
                                            {type.name}
                                        </option>
                                    ))
                                }
                            </select>      
                        </div>
                    )}
                    {withClients && (
                        <SearchClient
                            change={(e) => this.setUserEntity( 'client_id', ( e[0] && e[0].id )) }
                        />
                    )}
                    {(withProviders || withShoppers) && (
                        <SearchProvider
                            fromReports={withShoppers}
                            type={ withShoppers ? 'shopper' : 'provider'}
                            change={(e) => this.setUserEntity( 'provider_id', ( e[0] && e[0].id )) }
                        />
                    )}
                    {withCityFilter && (
                        forceCity && this.props.cityId ? (
                            <span>{cityLabel}</span>
                        ) : (
                            <Fragment>
                                <Label className={'text-muted text-left' } style={{width:`100%`}}>Ciudad</Label>
                                <SelectNormal
                                    className="mb-4"
                                    disabled={this.props.companyCities.length === 0}
                                    name={"city_select"}
                                    text_init={this.props.companyCities.length === 0 ? this.props.loadingText : forceCity ? "Seleccione una ciudad" : 'Todas'}
                                    refs={"city_select"}
                                    options={this.props.companyCities.map((city) => ({ name: city.name, id: city.id }))}
                                    val= {this.state[this.props.title] ? this.state[this.props.title] : ''}
                                    onchange={(e) => this.onCityChange(e.target)}/>
                            </Fragment>
                        )
                    )}
                </div>
            </td>
            <td className="text-left">
                {withDates && (
                    <Fragment>
                        <Label className={'text-muted text-left' } style={{width:`100%`}}>Desde</Label>
                        <DatetimePickerTrigger
                            shortcuts={shortcuts}
                            moment={start || moment()}
                            minDate={maxDateRange ? end ? moment(end).subtract(maxDateRange.time, maxDateRange.count) : null : null }
                            showTimePicker={false}
                            onChange={this.handleSetStart}>
                            <Input type="text" value={start ? start.format('YYYY-MM-DD') : 'Seleccione'} readOnly/>
                        </DatetimePickerTrigger>
                    </Fragment>
                )}
            </td>
            {
                start ? (
                    <td className="text-left">
                        {withDates && (
                            <Fragment>
                                <Label className={'text-muted text-left' } style={{width:`100%`}}>Hasta</Label>
                                <DatetimePickerTrigger
                                    shortcuts={shortcuts}
                                    minDate={start}
                                    maxDate={maxDateRange ? start ? moment(start).add(maxDateRange.time, maxDateRange.count) : null : null }
                                    moment={end || moment()}
                                    showTimePicker={false}
                                    onChange={this.handleSetEnd}>
                                    <Input type="text" value={end ? end.format('YYYY-MM-DD') : 'Seleccione'} readOnly/>
                                </DatetimePickerTrigger>
                            </Fragment>
                        )}
                    </td>
                ) : <td className="text-left"></td>
            }
            <td>
                {
                    activateModal ?<button
                        disabled={
                            this.props.withAllBranches
                            ? false
                            : (this.isGenerateButtonEnabled({ start, end }, query, this.props) ? false : true)
                        }
                        className={[
                            "btn btn-primary pull-right"
                        ].join(' ')}
                        // onClick={()=> console.log(this.refs) }>
                        onClick={()=> this.refs[`report`].toggleModal() }>
                        <i className="fa fa-file-pdf-o" /> { loading ? loadingText : buttonText }
                    </button>
                     /*<a
                        href={this.buildURL({ start, end }, query)}
                        target="_blank"
                        onClick={(e) => {
                            this.refs[`report`].toggleModal();
                            if (!withoutPrefetch) {
                                this.prefetch(e, this.buildURL({ start, end }, query))
                            }
                        }}
                        className={[
                            "btn btn-primary pull-right",
                            this.isGenerateButtonEnabled({ start, end }, query, this.props) ? '' : 'disabled'
                        ].join(' ')}
                        download>
                        <i className="fa fa-file-pdf-o" /> { loading ? loadingText : buttonText }
                    </a>*/
                    :
                    withFile ?
                        <label
                        className="btn btn-primary pull-right mx-2 mt-2"
                        htmlFor="file"
                        >
                            {this.state.uploading ? (
                                        <div
                                            style={{
                                                position: "relative",
                                                width: "50px",
                                                height: "20px",
                                            }}
                                        >
                                            <div className="preloader pls-white">
                                                <svg
                                                    className="pl-circular"
                                                    viewBox="25 25 50 50"
                                                >
                                                    <circle
                                                        className="plc-path"
                                                        cx={50}
                                                        cy={50}
                                                        r={20}
                                                    />
                                                </svg>
                                            </div>
                                        </div>
                                    ) : (
                                        <Fragment>
                                            <i className="fa fa-upload mr-2" />
                                            Subir
                                        </Fragment>
                                    )}
                            <input
                                type="file"
                                className="d-none"
                                id="file"
                                accept=".xlsx, .xlsm, .xltx, .xltm, .xls, .xlt, .ods, .ots, .slk, .xml, .gnumeric, .htm, .html, .csv, .tsv, .txt"
                                onChange={(event) => this.prepareUpload(event)}
                            />
                        </label>
                    :
                    <button
                        //href={this.buildURL({ start, end }, query)}
                        //target="_blank"
                        disabled={
                            this.props.withAllBranches
                            ? false
                            : (this.isGenerateButtonEnabled({ start, end }, query, this.props) ? false : true)
                        }
                        onClick={(e) => {
                            if (!withoutPrefetch) {
                                this.prefetch(e, this.buildURL({ start, end }, query, this.prop))
                            }
                        }}
                        className={[
                            "btn btn-primary pull-right"
                        ].join(' ')}
                        download>
                        <i className="fa fa-file-pdf-o" /> { loading ? loadingText : buttonText }
                    </button>
                }
            </td>
            {
                activateModal && <ModalBase ref={ `report` }
                    //confirmFunc={() => this.props.update(this.props.admin)}
                    title={this.buildTitle()}
                    html={ <ModalReport tittle={ this.buildTitle() } urlReport={this.buildURL({ start, end }, query)}/> } />
            }

        </tr>
    }
}

ReportItemRow.defaultProps = {
    title: '',
    withDates: false,
    withBranches: false,
    branchAsParameter: false,
    withClients: false,
    withoutPrefetch: false,
    withoutToken: false,
    withoutTimezone: false,
    withProviders: false,
    withShoppers: false,
    appendingQueryString: false,
    withTargetType: false,
    url: '',
    buttonText: 'Generar',
    loadingText: 'Cargando...',
    autoBranch: false,
    maxDateRange: undefined,
    logQueryBuildStart: () => {},
    logQueryBuildEnd: () => {},
    logQueryBuildAutoBranch: () => {},
    logQueryBuildAutoBranchGroup: () => {},
    logBranchSelection: () => {}
}
/*if(clients && clients.data){
    console.log("clients",clients.data.filter(client => (parseInt(client.account.status, 10) & 255) === 240))
}*/

export default connect(({ branches, branch, allClients, company, providers, companyCities }) => ({
    branches,
    branch,
    company,
    companyCities,
    clients: allClients && allClients.data ? allClients.data.filter(client => (parseInt(client.account.status, 10) & 255) === 240) : [], // TODO: translate this bitwise operation into a helper function
    providers: providers && providers.data ? providers.data.filter(provider => (parseInt(provider.account.status, 10) & 255) === 240) : [], // TODO: translate this bitwise operation into a helper function
    hasBranch: hasBranch(branch)
}))(withApiService(ReportItemRow))



// WEBPACK FOOTER //
// ./src/views/Reports/ReportItemRow.js